// Author - Atul Pandey
// Updated - 25 Feb 2025 - refined the roles list for coach/ admin/ sponsor
// Updated - 06 May 2025 - added isOrgAdmin flag
// Updated - 21 May 2025 - added token
// Updated - 26 Jun 2026 - expanded role auth list for org leaders
// Updated - 08 Sep 2026 - expanded role auth list for org Igniters
// Updated - 24 Sep 2026 - added isOrgFacilitator flag

import { useSelector } from 'react-redux'
import { selectCurrentToken } from "../features/auth/authSlice"
import {jwtDecode} from 'jwt-decode'

const useAuth = () => {

    const token = useSelector(selectCurrentToken)

    // console.log('The token is',token)

    let isCoach = false
    let isAdmin = false
    let isSponsor = false
    let status = "Guest"

    let isOrgAdmin = false // 👈 NEW - 06 May 2025


    let isEtAdmin = false // 31 Jan 2026
    let isEtCoach = false // 31 Jan 2026


    let isOrgLeader = false // 26 Jun 2026


    let isOrgIgniter = false // 08 Sep 2026


    let isOrgFacilitator = false // 24 Sep 2026


    if (token) {

        const decoded = jwtDecode(token)

        //console.log('The decoded token', decoded)

        const { 
            name, 
            username, 
            roles, 
        } = decoded.UserInfo

        //console.log('UserName:',username, 'Roles:',roles)


        // isCoach = roles.includes('Coach')
        // isAdmin = roles.includes('Admin')


        isCoach = roles.some(
            role => [
                'Coach',
                'EtCoach',
                'OrgCoach'
            ].includes(role)
        ) 
        // 25 Feb 2025


        // isAdmin = roles.some(role => ['Admin', 'EtAdmin', 'OrgAdmin'].includes(role));          
        // 25 Feb 2025


        isAdmin = roles.some(
            role => [
                'Admin',
                'EtAdmin'
            ].includes(role)
        )
        // 06 May 2025


        isSponsor = roles.some(
            role => [
                'OrgSponsor'
            ].includes(role)
        )
        // 25 Feb 2025


        isOrgAdmin = roles.some(
            role => [
                'OrgAdmin',
                'OrgSponsor'
            ].includes(role)
        )
        // 06 May 2025 ✅ NEW



        /*
        |--------------------------------------------------------------------------
        | Et Roles
        |--------------------------------------------------------------------------
        */

        // 31 Jan 2026

        isEtAdmin = roles.some(
            role => [
                'EtAdmin'
            ].includes(role)
        )


        isEtCoach = roles.some(
            role => [
                'EtCoach'
            ].includes(role)
        )



        /*
        |--------------------------------------------------------------------------
        | Org Leaders
        |--------------------------------------------------------------------------
        */

        // 26 Jun 2026

        isOrgLeader = roles.some(
            role => [
                'OrgCxO',         
                'OrgBULeader',    
                'OrgLeader',      
            ].includes(role)
        )



        /*
        |--------------------------------------------------------------------------
        | Org Igniters
        |--------------------------------------------------------------------------
        */

        // 08 Sep 2026

        isOrgIgniter = roles.some(
            role => [
                'OrgCxO',         
                'OrgBULeader',    
                'OrgLeader', 
                'OrgFacilitator',
                'OrgCoach',
                'OrgSponsor',
                'OrgAdmin',
            ].includes(role)
        )



        /*
        |--------------------------------------------------------------------------
        | Org Facilitator
        |--------------------------------------------------------------------------
        */

        // 24 Sep 2026
        //
        // Explicit OrgFacilitator flag.
        //
        // This is intentionally separate from isOrgIgniter because
        // isOrgIgniter represents a broader group of Org leadership /
        // activation roles whereas some views require specifically
        // the OrgFacilitator role.

        isOrgFacilitator = roles.some(
            role => [
                'OrgFacilitator'
            ].includes(role)
        )



        /*
        |--------------------------------------------------------------------------
        | Status
        |--------------------------------------------------------------------------
        */

        if (isCoach) status = "Coach"

        if (isAdmin) status = "Admin"

        if (isSponsor) status = "Sponsor"
        // 25 Feb 2025


        if (isEtAdmin) status = "EtAdmin"
        // 31 Jan 2026


        if (isEtCoach) status = "EtCoach"
        // 31 Jan 2026
        

        if (isOrgLeader) status = "OrgLeader"
        // 26 Jun 2026


        if (isOrgIgniter) status = "OrgIgniter"
        // 08 Sep 2026



        /*
        |--------------------------------------------------------------------------
        | Return Authenticated User
        |--------------------------------------------------------------------------
        */

        return { 

            name, 

            username, 

            roles, 

            status, 

            isCoach, 

            isAdmin, 

            isSponsor,
            // 25 Feb 2025 

            isOrgAdmin,
            // 06 May 2025

            token,
            // 21 May 2025

            isEtAdmin,
            // 31 Jan 2026 

            isEtCoach,
            // 31 Jan 2026 

            isOrgLeader,
            // 26 Jun 2026 

            isOrgIgniter,
            // 08 Sep 2026

            isOrgFacilitator,
            // 24 Sep 2026

        } 
    }



    /*
    |--------------------------------------------------------------------------
    | Return Guest / No Token
    |--------------------------------------------------------------------------
    */

    return { 

        name: '', 

        username: '', 

        roles: [], 

        isCoach, 

        isAdmin, 

        isSponsor,
        // 25 Feb 2025    

        status, 

        isOrgAdmin,
        // 06 May 2025

        isEtAdmin,
        // 31 Jan 2026 

        isEtCoach,
        // 31 Jan 2026

        isOrgLeader,
        // 26 Jun 2026 

        isOrgIgniter,
        // 08 Sep 2026

        isOrgFacilitator,
        // 24 Sep 2026

    }    
}

export default useAuth